<button type="button" class="ps-gs-trigger" (click)="openPalette()" aria-label="Open global search">
  <em class="fas fa-search"></em>
  <span class="ps-gs-trigger__text">Search anything…</span>
  <kbd class="ps-gs-trigger__kbd">Ctrl K</kbd>
</button>

<div class="ps-gs" *ngIf="open" role="dialog" aria-modal="true" aria-label="Global search">
  <div class="ps-gs__backdrop" (click)="dismiss()"></div>
  <div class="ps-gs__panel">
    <div class="ps-gs__bar">
      <em class="fas fa-search ps-gs__bar-icon"></em>
      <input #searchInput class="ps-gs__input" type="text" [ngModel]="query"
        (ngModelChange)="onQueryChange($event)"
        placeholder="Search or say “open QA”, “quality assurance”…"
        autocomplete="off" spellcheck="false" />
      <button type="button" class="ps-gs__clear" *ngIf="query" (click)="clearQuery()" aria-label="Clear">Clear</button>
      <button type="button" class="ps-gs__mic"
        *ngIf="voiceSupported"
        [class.is-listening]="listening"
        (click)="toggleVoice($event)"
        [attr.aria-label]="listening ? 'Stop voice search' : 'Start voice search'"
        [title]="listening ? 'Stop listening' : 'Voice search'">
        <em class="fas" [ngClass]="listening ? 'fa-stop' : 'fa-microphone'"></em>
      </button>
      <button type="button" class="ps-gs__esc" (click)="dismiss()" aria-label="Close">Esc</button>
    </div>

    <div class="ps-gs__hint">
      <span>↑↓ navigate</span>
      <span>Enter open</span>
      <span>→ actions</span>
      <span>a: r: s: sc: q: i: p: filters</span>
      <span *ngIf="voiceSupported">🎙 voice</span>
      <a class="ps-gs__adv" routerLink="/global-search" (click)="close()">Advanced search</a>
    </div>
    <div class="ps-gs__voice-status" *ngIf="voiceStatus" [class.is-listening]="listening">
      <em class="fas" [ngClass]="listening ? 'fa-microphone' : 'fa-comment-dots'"></em>
      {{ voiceStatus }}
    </div>

    <div class="ps-gs__body">
      <div class="ps-gs__loading" *ngIf="loading">Searching…</div>

      <!-- Empty query: recent + shortcuts -->
      <ng-container *ngIf="!query && !loading">
        <div class="ps-gs__section" *ngIf="recent.length">
          <div class="ps-gs__section-head">
            <span>Recent</span>
            <button type="button" class="ps-gs__linkish" (click)="clearRecent()">Clear</button>
          </div>
          <button type="button" class="ps-gs__recent" *ngFor="let term of recent" (click)="selectRecent(term)">
            <em class="fas fa-history"></em>
            <span>{{ term }}</span>
          </button>
        </div>
        <div class="ps-gs__section">
          <div class="ps-gs__section-head"><span>Suggested</span></div>
          <button type="button" class="ps-gs-row" *ngFor="let item of shortcuts; trackBy: trackItem"
            (click)="actions.runPrimary(item); close()">
            <span class="ps-gs-row__icon"><em class="fas" [ngClass]="iconFor(item.type)"></em></span>
            <span class="ps-gs-row__main">
              <span class="ps-gs-row__title">{{ item.title }}</span>
              <span class="ps-gs-row__sub">{{ cleanText(item.subtitle) }}</span>
            </span>
          </button>
        </div>
      </ng-container>

      <div class="ps-gs__section" *ngFor="let group of groups; trackBy: trackGroup">
        <div class="ps-gs__section-head">
          <span>{{ group.label }}</span>
          <span class="ps-gs__count">{{ group.total }}</span>
        </div>

        <div class="ps-gs-row"
          *ngFor="let item of group.items; let i = index; trackBy: trackItem"
          [class.is-active]="flatRows[activeIndex]?.item === item"
          (click)="onRowClick({ groupLabel: group.label, item: item, flatIndex: getFlatIndex(item) })"
          (mouseenter)="activeIndex = getFlatIndex(item)">
          <span class="ps-gs-row__icon"><em class="fas" [ngClass]="iconFor(item.type)"></em></span>
          <span class="ps-gs-row__main">
            <span class="ps-gs-row__title">
              {{ item.title }}
              <span class="ps-gs-chip" *ngIf="item.status">{{ item.status }}</span>
            </span>
            <span class="ps-gs-row__sub" *ngIf="item.subtitle">{{ cleanText(item.subtitle) }}</span>
          </span>
          <span class="ps-gs-row__actions" *ngIf="item.actions?.length">
            <button type="button" class="ps-gs-row__primary"
              (click)="onActionClick(item.actions[0], item, $event)">
              {{ item.actions[0].label }}
            </button>
            <button type="button" class="ps-gs-row__more" *ngIf="item.actions.length > 1"
              (click)="toggleActionMenu(getFlatIndex(item), $event)" aria-label="More actions">
              <em class="fas fa-ellipsis-v"></em>
            </button>
            <div class="ps-gs-menu" *ngIf="actionMenuIndex === getFlatIndex(item)">
              <button type="button" *ngFor="let action of item.actions"
                (click)="onActionClick(action, item, $event)">
                {{ action.label }}
              </button>
            </div>
          </span>
        </div>
      </div>

      <div class="ps-gs__empty" *ngIf="query && !loading && !groups?.length">
        No matches for “{{ query }}”. Try a name, application id, company, or prefix like <code>s:</code> / <code>p:</code>.
      </div>
    </div>
  </div>
</div>
